import {useIntl} from 'react-intl'
import {ID} from '../../../../../../../_metronic/helpers'
import {useState} from 'react'
import {ContractsModal} from '../../../../../../../_metronic/partials/modals/contracts/ContractsModal'

import {EmptyState} from '../../../../../shared/components/EmptyState'

const ContractsPlaceholder = () => {
  const intl = useIntl()
  const [showModal, setShowModal] = useState<boolean>(false)
  const [contractId] = useState<ID>(undefined)

  return (
    <div id='kt_projects_cards_pane' className='dash-section'>
      <EmptyState
        icon='bi-file-earmark-text'
        title={intl.formatMessage({id: 'PROJECT.CREATE_NOT_RECORDS_CONTRACT'})}
        description='Os contratos cadastrados nos clientes e projetos aparecem aqui.'
      />
      <ContractsModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        projectId={undefined}
        clientId={undefined}
        contractId={contractId}
      />
    </div>
  )
}

export {ContractsPlaceholder}
